(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owais-parts-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('owais-parts-finder')) {
    customElements.define('owais-parts-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.fields = [...this.querySelectorAll('select')];
        this.status = this.querySelector('[role="status"]');
        this.form.addEventListener('change', (event) => this.updateOptions(event.target));
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          const url = this.buildUrl();
          window.location.assign(url.href);
        });
      }
      buildUrl() {
        const url = new URL(this.form.action, location.origin);
        this.fields.forEach(field => { if (field.value) url.searchParams.set(field.name, field.value); });
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        return url;
      }
      async updateOptions(changed) {
        const index = this.fields.indexOf(changed);
        if (index < 0 || index === this.fields.length - 1) return;
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        this.fields.slice(index + 1).forEach(field => { field.value = ''; field.disabled = true; });
        const submit = this.querySelector('button');
        submit.disabled = true;
        this.status.textContent = this.status.dataset.loading;
        this.setAttribute('aria-busy', 'true');
        try {
          const url = this.buildUrl();
          url.searchParams.set('section_id', 'owais-parts-finder');
          const response = await fetch(url, { signal:controller.signal });
          if (!response.ok) throw new Error('Request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = [...html.querySelectorAll('owais-parts-finder select')];
          if (incoming.length !== this.fields.length) throw new Error('Missing filters');
          this.fields.slice(index + 1).forEach((field, offset) => {
            field.replaceChildren(...[...incoming[index + offset + 1].options].map(option => option.cloneNode(true)));
            field.value = '';
          });
          this.status.textContent = '';
        } catch (error) {
          if (error.name !== 'AbortError') this.status.textContent = this.status.dataset.error;
        } finally {
          if (this.controller === controller) {
            this.fields.forEach(field => { field.disabled = false; });
            submit.disabled = false;
            this.removeAttribute('aria-busy');
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
